import React, { useState,useEffect } from 'react';
// import {} from 'react-router-dom'
import { useSelector } from 'react-redux';
import { useGetAllObjectiveByPeriodId,useGetAllPersonPictureByTenantId} from '../../Hooks/index';
import {Box,Grid,Typography} from '@mui/material';
// import { AllOKRComponentFace } from '../../Interfaces/Interfaces';
// import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
// import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import {CircularProgress} from '@mui/material';
// import { useNavigate,useParams } from 'react-router-dom';
import TORCart from '../TORCart/TORCart';



const AllTOKRs = ({periodId,teamId}:any) => {
  const[allObjective,setAllObjective]=useState<any[]>();
  const[objectiveC,setObjectiveCount]=useState<any>();
  const[keyResultC,setKeyResultCount]=useState<any>();
  const[scoreC,setScore]=useState<any>();
  const profileTenantId=useSelector((state:any)=>state.meetings.profileTenantId);
  const{data:objetcideData,isLoading:getObjectiveLoading,isFetched}=useGetAllObjectiveByPeriodId(periodId,teamId);
  const{data:picData,isLoading:loading}=useGetAllPersonPictureByTenantId(profileTenantId);

let { objectives,objectiveCount,keyResultCount,score } = objetcideData || {}

  useEffect(() => {

    setAllObjective(objectives)

  }, [objectives])

  useEffect(() => {

    setObjectiveCount(objectiveCount)

  }, [objectiveCount])

  useEffect(() => {

    setKeyResultCount(keyResultCount)

  }, [keyResultCount])

  useEffect(() => {

    setScore(score)

  }, [score])


  if (getObjectiveLoading || !allObjective || isFetched!==true) {
    return <Box display={'flex'} 
    alignItems={'center'} 
    justifyContent={'center'} 
    width={'100%'} 
    height={'500px'} 
     >
      <CircularProgress  />
     </Box>
  }
  
  return (
    <>
        <Grid item xs={12}  >
        {
         allObjective !== undefined && allObjective !== null ?
         <Grid container  >
          <Grid display={'flex'} flexDirection={'row-reverse'} justifyContent={'space-between'} item xs={12}  >
       <Box 
        margin={4}
        // bgcolor={keyResultC / objectiveC>= 5 ?'#FFF8D0' : keyResultC / objectiveC <5 && keyResultC / objectiveC > 3 ? '#d5f7d4': '#FFEEE5 '}
        // color={keyResultC / objectiveC>= 5 ?'#6B6440' : keyResultC / objectiveC<5 && keyResultC / objectiveC> 3 ? '#125610': '#993600 '}
        bgcolor={scoreC>= 70 ?'#d5f7d4' : scoreC <70 && scoreC > 30 ? '#FFF8D0': '#FFEEE5 '}
        color={scoreC>= 70 ?'#125610' : scoreC <70 && scoreC > 30 ? '#6B6440': '#993600 '}
        borderRadius={10}
        boxShadow={5}
          py={2}
          px={4}
         width={'50%'}
         display={'flex'}
         flexDirection={'column'} alignItems={'center'} >
         <Typography fontWeight={600}>
        تعداد نتیجه کلیدی:  {keyResultC} </Typography> </Box>
         <Box 
        margin={4}
        bgcolor={scoreC>= 70 ?'#d5f7d4' : scoreC <70 && scoreC > 30 ? '#FFF8D0': '#FFEEE5 '}
        color={scoreC>= 70 ?'#125610' : scoreC <70 && scoreC > 30 ? '#6B6440': '#993600 '}
        borderRadius={10}
        boxShadow={5}
          py={2}
          px={4}
         
         width={'50%'}
         display={'flex'}
         flexDirection={'column'} alignItems={'center'} >
         <Typography fontWeight={600}>
        تعداد هدف:  {objectiveC} </Typography> </Box>
         <Box 
        margin={4}
        bgcolor={scoreC>= 70 ?'#d5f7d4' : scoreC <70 && scoreC > 30 ? '#FFF8D0': '#FFEEE5 '}
        color={scoreC>= 70 ?'#125610' : scoreC <70 && scoreC > 30 ? '#6B6440': '#993600 '}
        borderRadius={10}
        boxShadow={5}
          py={2}
          px={4}
         width={'50%'}
         display={'flex'}
         flexDirection={'column'} alignItems={'center'} >
         <Typography fontWeight={600}>
        امتیاز:  {scoreC} </Typography> </Box>
        </Grid>
        <Grid item xs={12}  >
        <Grid container spacing={1} px={1} >
       {
        allObjective && allObjective.map((o:any,i:number)=>{
          return <Grid  item xs={12} sm={12}  >
            <Box width={'100%'} key={i}   >
            <TORCart obj={o}   
            // setShowToastMessage={setShowToastMessage}
            // afterSuccess={getObjectivesAgain}
            // setObjectiveId = {setObjectiveId}
            item={o}
            num={i}
            personPicture={picData}
            />
          </Box>
          </Grid>
        })
      }
       </Grid> 
      </Grid>
         </Grid>
        :
        <Grid container  >
              <Box width={'100%'} textAlign={'center'} p={2}   >
                <Box>
                  <Typography textAlign={'center'} fontWeight={500} fontSize={'18px'} variant='body2'   >
                    هدفی در این دوره‌‌زمانی تعریف نشده است.
                  </Typography>
                </Box>
              </Box>
          </Grid>
        }
        </Grid>
    </>
  )
}

export default AllTOKRs